import React, { Component } from "react";
import { PageHeader, ListGroup, ListGroupItem, Breadcrumb, Table } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import "./Home.css";
import { API } from "aws-amplify";
import FTCLogo from "../images/ftc_logo.png";
import FTCLogoFull from "../images/ftc_logo_full_right.png";
import ProjectsIcon from "../images/projects.png";
import AccountIcon from "../images/my_account.png";
import UsersIcon from "../images/users.png";

export default class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      notes: []
    };
  }
async componentDidMount() {
      //console.log('#########');
      //console.log(this.props);
      //console.log('@@@@@@@@@');
  if (!this.props.isAuthenticated) {
    return;
  }
  /*
  try {
    const notes = await this.notes();
    this.setState({ notes });
  } catch (e) {
    alert(e);
  }
  */

  this.setState({ isLoading: false });
}

notes() {
  return API.get("ftc", "/notes");
}
/*
 renderNotesList(notes) {
  return [{}].concat(notes).map(
    (note, i) =>
      i !== 0
        ? <ListGroupItem
            key={note.noteId}
            href={`/notes/${note.noteId}`}
            onClick={this.handleNoteClick}
            header={note.content.trim().split("\n")[0]}
          >
            {"Created: " + new Date(note.createdAt).toLocaleString()}
          </ListGroupItem>
        : <ListGroupItem
            key="new"
            href={"/builder"}
            onClick={this.handleBuilderClick}
          >
            <h4>
              <b>{"\uFF0B"}</b> New survey schema
            </h4>
          </ListGroupItem>
  );
}
*/
/*
 renderNotesList(notes) {
  return [{}].concat(notes).map(
    (note, i) =>
      i !== 0
        ? <ListGroupItem
            key={note.noteId}
            href={`/notes/${note.noteId}`}
            onClick={this.handleNoteClick}
            header={note.content.trim().split("\n")[0]}
          >
            {"Created: " + new Date(note.createdAt).toLocaleString()}
          </ListGroupItem>
        : <ListGroupItem
            key="new"
            href={"/notes/new"}
            onClick={this.handleNoteClick}
          >
            <h4>
              <b>{"\uFF0B"}</b> New Project
            </h4>
          </ListGroupItem>
  );
}
*/
handleBuilderClick = event => {
  event.preventDefault();
  sessionStorage.setItem('schema_id', 'Tom');
  this.props.history.push(event.currentTarget.getAttribute("href"));
}
handleProjectsClick = event => {
  event.preventDefault();
  this.props.history.push("/projects");
}

handleWeatherDataClick = event => {
  event.preventDefault();
  this.props.history.push("/weather");
}
handleSensorDataClick = event => {
  event.preventDefault();
  this.props.history.push("/sensordata");
}
handleMappingClick = event => {
  event.preventDefault();
  this.props.history.push("/mapviewer");
}






handleNoteClick = event => {
  event.preventDefault();
    sessionStorage.setItem('schema_id', event.currentTarget.getAttribute("key"));
  this.props.history.push(event.currentTarget.getAttribute("href"));
}
  renderLander() {
    return (
      <div style={{textAlign: 'center', position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
        <img src={FTCLogoFull} style={{maxWidth: '100%', height: 'auto'}}/>

      </div>
    );
  }
  //<p className="title">A fully configurable field data collection, analysis and distribution app.</p>
  renderOptions() {
    return (
      <div>
      <Breadcrumb style={{top: 58, left: 66, right: 0, position: 'absolute', zIndex:999, backgroundColor: '#FFF'}}>
    <Breadcrumb.Item active>Home</Breadcrumb.Item>
  </Breadcrumb>
  <div className="options" style={{display: 'flex', position: 'absolute', left:80, right:80,top: 40, paddingBottom:50}}>

    <div className="lander" style={{display: 'inline-block', width:'100%', aligntop:'0px'}}>
      <div className="landerButton" onClick={this.handleProjectsClick}>
<img  src={ProjectsIcon} />
<p className="title"><b>Projects</b></p>
<p className="desc">Create and manage your projects, design and build schemas and view and manage trips.</p>
</div>
<div className="landerButton" onClick={this.handleProjectsClick}>
<img src={AccountIcon} />
<p className="title"><b>My Account</b></p>
<p className="desc">Manage you account details.</p>
</div>
<div className="landerButton" onClick={this.handleProjectsClick}>
<img  src={UsersIcon} />
<p className="title"><b>Team</b></p>
<p className="desc">Create and assign roles to your team members.</p>
</div>
<br/>
<div className="landerButton" onClick={this.handleWeatherDataClick}>
<img  src={ProjectsIcon} />
<p className="title"><b>Weather Data</b></p>
<p className="desc">View weather and pic station data.</p>
</div>
<div className="landerButton" onClick={this.handleSensorDataClick}>
<img  src={ProjectsIcon} />
<p className="title"><b>Sensor Data</b></p>
<p className="desc">View remote sensor data.</p>
</div>


<div className="mappingButton" onClick={this.handleMappingClick}>
<img  src={ProjectsIcon} />
<p className="title"><b>Rewilding</b></p>
<p className="desc">Rewilding app map prototyping.</p>
</div>


<div style={{ display: 'flex', width:'100%', height: 'calc(100vh - 462px)'}}>
<img style={{ height:'100%', margin: 'auto', opacity: 0.05, filter: 'alpha(opacity=10)'}} src={FTCLogo}/>
</div>


      </div></div></div>
    );
  }
  /*
renderNotes() {
    return (

      <div className="notes">
    <Breadcrumb>
  <Breadcrumb.Item active>Home</Breadcrumb.Item>
</Breadcrumb>
        <PageHeader>{this.props.org ? this.props.org.orgName + ':' : 'My'} Projects</PageHeader>
        <ListGroup>
          {!this.state.isLoading && this.renderNotesList(this.state.notes)}
        </ListGroup>

        <Table>
        <tbody>
        <tr>

        <td>
          <LoaderButton

            bsStyle="primary"
            bsSize="large"
            isLoading={this.state.isLoading}
            onClick={this.handleProjectsClick}
            text="Projects"
            loadingText="Projects…"
          />
          </td>
          <td>
          <LoaderButton

            bsStyle="primary"
            bsSize="large"
            isLoading={this.state.isLoading}
            onClick={this.handleProjectsClick}
            text="My Account"
            loadingText="Account…"
          />
          </td>
          </tr>
          </tbody>
          <tbody>
          <tr>
          <td>
          <LoaderButton

            bsStyle="primary"
            bsSize="large"
            isLoading={this.state.isLoading}
            onClick={this.handleProjectsClick}
            text="Manage Users"
            loadingText="Manage…"
          />
          </td>
          <td>
          <LoaderButton

            bsStyle="primary"
            bsSize="large"
            isLoading={this.state.isLoading}
            onClick={this.handleProjectsClick}
            text="Contact / Help"
            loadingText="Contact"
          />
          </td>
          </tr>
          </tbody>
          </Table>



      </div>
    );
  }
*/
  render() {
    return (
      <div className="Home">
        {this.props.isAuthenticated ? this.renderOptions() : this.renderLander()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Home.js